import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { HttpService } from "../../service/HTTPService/HttpService";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
import { map, switchMap } from "rxjs";

@Component({
  selector: "app-actions-cell",
  template: `<div id="alarmRenderer">
    <div id="detailedsiteList" style="overflow:hidden;text-overflow:ellipsis">
      <a
        title="{{ params.value }}"
        (click)="opennewwindow()"
        style="text-decoration:none;color:#007bff;cursor:pointer"
        >{{ params.value }}
      </a>
      <div
        style="float:right;margin  :12px 10px"
        (click)="getModules(params)"
        placement="right"
        #popover="ngbPopover"
        [ngbPopover]="alarmInfo"
        container="body"
      >
        <img
          src="assets/img/1.png"
          alt="Bell Icon"
          width="{{ width }}"
          height="{{ height }}"
        />
      </div>
      <!-- <div style="padding-right: 12px; display: inline">
        <ng-template #alarmInfo>
          <div id="alarmList">
            <div class="alrmhead">
              <b>{{ siteDetails }}</b>
            </div>

            <div *ngFor="let item of module">
              <ul class="alarmInfo">
                <li>
                  {{ item.Alarm }}
                  <label style="padding-left: 15px;" class="listLabel">{{
                    item["GeneratedOn"]
                  }}</label>
                </li>
              </ul>
            </div>
          </div>
        </ng-template>  
      </div> -->
      <div style="padding-right: 12px; display: inline">
        <ng-template #alarmInfo>
          <div id="alarmList">
            <div class="cardTitle">
              <div>{{ siteDetails }}</div>
            </div>
            <div *ngIf="alarmLoader" class="loader-overlay">
              <app-divLoader></app-divLoader>
            </div>
            <div *ngFor="let mod of libBatteryDetails; index as i">
              <div *ngIf="mod.alarmList.length">
                <div style="padding:5px 10px;  background-color: #dddd; ">
                  <div>{{ mod.Module }}</div>
                </div>

                <div *ngFor="let item of mod.alarmList">
                  <div class="alarmInfo">
                    <div
                      class="alarmName"
                      [ngStyle]="{
                        'border-left': '8px solid' + item.color,
                      }"
                    >
                      <span>{{ item.alarmName }}</span>
                    </div>
                  </div>
                </div>

                <!-- <div class="px-5" *ngIf="!mod.alarmList.length">
                  No Active Alarms
                </div> -->
              </div>
            </div>
            <div class="noData" *ngIf="!libBatteryDetails.length">
              No Data Available
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div> `,
  styles: [
    `
      .cardTitle {
        padding: 5px;
        font-weight: 700;
      }
      .alarmName {
        height: 22px;
        padding: 5px 0px 30px 10px;
      }
      .alarmInfo {
        border-bottom: 1px solid #dddddd;
        list-style-type: none;
        margin: 0px;
        padding: 6px 5px;
        background: #ffffff;
      }
      .listLabel {
        margin-bottom: 5px;
        float: right;
      }
      #alarmList {
        height: 320px;
        overflow-y: auto;
        min-width: 350px;
      }
      .alrmhead {
        background: #dddd;
        padding: 5px;
        border-radius: 5px 5px 0 0;
      }
      .noData {
        height: 100px;
        display: flex;
        padding: 10px 20px;
        text-align: center;
        justify-content: center;
        align-items: center;
      }
    `,
  ],
})
export class SiteListRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public colors = "";
  public width = "";
  public height = "";
  public sid = "";
  public link = "";
  module;
  DCPowerDatas1 = false;
  DCPowerDatas = true;
  site;
  lastUp;
  lastUpdated;
  datetimeformat;
  siteCode;
  siteName;
  alarmList = [];
  selectedDateFormat;
  selectedTimeFormat;
  format;
  timeFormatforGrid;
  siteDetails;
  userType;
  alarmLoader: boolean = false;
  libBatteryDetails;
  constructor(
    private urlAuthentication: BindingURLService,
    private http: HttpService,
    private apiUrl: ApiService,
  ) {}
  agInit(params: any): void {
    this.userType = sessionStorage.getItem("userType");
    let priority = "";
    this.colors = "";
    this.params = params;
    priority = this.params.data.BatteryAlarmStatus;
    this.sid = this.params.data.SiteID;
    this.site = this.params.data.SiteName;
    let siteCode = this.params.data.siteCode;
    this.lastUp = this.params.data.LastUpdated;
    let url = this.params.colDef.customParam;
    // this.link = !url ? "#/siteDetails" : `#/${url}`;
    // this.link = !url ? "#/energydash" : `#/${url}`;
    const isOMC = (window as any).__env?.isOMCCustomerEnergyDashPage === true;
    this.link = !url ? (isOMC ? "#/energydash" : "#/siteDetails") : `#/${url}`;

    const str = JSON.stringify({
      siteID: this.sid,
      siteCode: siteCode,
      siteName: this.site,
    });
    // const encr = window.btoa(str);
    const encr = window.btoa(encodeURIComponent(str));
    this.link = this.link + "?e=" + encr;
    if (priority == "1") {
      this.width = "18";
      this.height = "18";
    } else {
      this.width = "0";
      this.height = "0";
    }
  }

  ngOnInit() {}

  refresh(): boolean {
    return false;
  }
  opennewwindow() {
    window.open(this.link);
    // window.open(this.link, '_self');
  }

  getModules(val) {
    this.siteCode = "";
    this.siteName = "";
    this.lastUpdated = "";
    this.siteDetails = "";
    this.siteName = val.data.SiteName;
    this.siteCode = val.data.siteCode;
    this.siteDetails = this.siteCode + " | " + this.siteName;
    this.displayAlarm();
  }

  displayAlarm() {
    this.alarmLoader = true;
    let reqJson = {
      fmID: 1509,
      siteID: this.sid.toString(),
    };

    this.http
      .genericApi(this.urlAuthentication.genericApiUrl, reqJson)
      .pipe(
        map((res) => res.response[0].Data),
        switchMap((alarmStatus) => this.getAlarmLabel(alarmStatus)),
      )
      .subscribe(
        (processedAlarms) => {
          this.libBatteryDetails = processedAlarms;
          this.libBatteryDetails = this.libBatteryDetails.filter(
            (battery) => battery.alarmList.length > 0,
          );
          this.alarmLoader = false;
        },
        (error) => {
          console.error(error);
          this.alarmLoader = false;
        },
      );
  }

  getAlarmLabel(alarmStatus) {
    let reqJson = {
      fmID: 309,
      Accountflag: "1",
    };

    return this.http
      .post(
        this.urlAuthentication.alarmLogUrl + this.apiUrl.getalarmGenericData,
        reqJson,
      )
      .pipe(
        map((res) => res.response[0].data),
        map((alarmNamePin) => {
          const groupedAlarms = alarmNamePin.reduce((acc, pin) => {
            if (!acc[pin.mtrSlaveID]) {
              acc[pin.mtrSlaveID] = [];
            }
            acc[pin.mtrSlaveID].push(pin);
            return acc;
          }, {});

          const siteLibAlarms = alarmStatus.map((status, index) => {
            const moduleAlarms =
              groupedAlarms[status.mtrUniqueID]
                ?.filter((pin) => status[pin.Alarmpin] === 1)
                .map((pin) => {
                  return {
                    alarmStatus: status[pin.Alarmpin] || 0,
                    color: status[pin.Alarmpin] === 0 ? "#09AF00" : "#E57373",
                    alarmName: pin.Alarmname,
                    Alarmpin: pin.Alarmpin,
                  };
                }) || [];

            return {
              Module: `Module ${index + 1}`,
              mtrUniqueID: status.mtrUniqueID,
              alarmList: moduleAlarms,
            };
          });

          return siteLibAlarms;
        }),
      );
  }
}
